import { inject } from '@angular/core';
import { TaApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const taTableConfig = (): TableConfig => {
  const taApiService = inject(TaApiService);

  return {
    title: 'Danh sách trợ giảng',
    entityName: 'trợ giảng',
    service: taApiService,
    method: 'getTas',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text'},
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text'},
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text'},
      { field: 'employeePosition.status', header: 'Tình trạng', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'employeePositionStatus' },
      { field: 'taClusters', header: 'Cụm làm việc', width: 'min-w-[150px]', sortable: false, type: 'custom' },
      { field: 'taTrainings.PLACEMENT', header: 'Tester', width: 'min-w-[60px]', sortable: false, type: 'custom' },
      { field: 'taTrainings.STUDY_SPACE', header: 'SS', width: 'min-w-[50px]', sortable: false, type: 'custom' },
      { field: 'taTrainings.TEACHING_ASSIST', header: 'TA lớp', width: 'min-w-[200px]', sortable: false, type: 'custom' },
      { field: 'taTrainings.TUTOR', header: 'Tutor', width: 'min-w-[200px]', sortable: false, type: 'custom' },
      { field: 'taTrainings.PROCTOR', header: 'Gác thi', width: 'min-w-[50px]', sortable: false, type: 'custom' },
      { field: 'taTrainings.EXAMINER', header: 'Giám khảo', width: 'min-w-[70px]', sortable: false, type: 'custom' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'row',
        tooltip: 'Đổi cụm',
        icon: 'pi pi-sitemap',
        permission: PERMISSIONS.TA_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.CHANGE_CLUSTER
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.TA_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
